import React, { useMemo } from "react";
import Select from "../../shared/Select";
import { Tooltip } from "@mui/material";

const SubjectSettingTableRow = ({
  subject,
  data,
  handleChange,
  staffListOptions,
}) => {
  const isConfigured = useMemo(() => {
    if (!data) return false;

    return data?.educationLevelDivisions?.some((item) => item?.isConfigured);
  }, [data]);

  return (
    <tr>
      <td>
        <Tooltip
          title={
            isConfigured
              ? `${subject?.name} has already been configured for this class in the assessment. Therefore you cannot unselect it`
              : ""
          }
        >
          <input
            aria-label="class-checkbox"
            className="checkbox"
            type="checkbox"
            checked={data?.checked || isConfigured || false}
            name="checked"
            disabled={isConfigured}
            onChange={(e) => handleChange(data.id, e)}
          />
        </Tooltip>
      </td>
      <td style={{ whiteSpace: "nowrap" }}>{data?.name}</td>
      {subject?.hasTheory && (
        <td>
          <input
            className="form-control"
            type="number"
            aria-label="creditHourTheory"
            value={data?.creditHourTheory}
            name="creditHourTheory"
            onChange={(e) => handleChange(data.id, e)}
            disabled={!data?.checked}
            min={0}
            onKeyDown={(e) => {
              if (e.key === "-" || e.key === "e") {
                e.preventDefault();
                return;
              }
            }}
          />
        </td>
      )}
      {subject?.hasPractical && (
        <td>
          <input
            className="form-control"
            type="number"
            aria-label="creditHourPractical"
            value={data?.creditHourPractical}
            name="creditHourPractical"
            onChange={(e) => handleChange(data.id, e)}
            disabled={!data?.checked}
            min={0}
            onKeyDown={(e) => {
              if (e.key === "-" || e.key === "e") {
                e.preventDefault();
                return;
              }
            }}
          />
        </td>
      )}
      <td>
        <input
          className="form-control"
          type="number"
          aria-label="creditHour"
          value={data?.creditHour}
          name="creditHour"
          disabled={true}
        />
      </td>
      <td>
        {data?.educationLevelDivisions?.length > 0 ? (
          <div
            className="checkbox-wrapper"
            style={{
              display: "grid",
              gap: "8px",
              gridTemplateColumns: "1fr 1fr",
            }}
          >
            {data?.educationLevelDivisions?.map((item) => (
              <React.Fragment key={item.educationLevelDivisionId}>
                <div className="checkbox">
                  <Tooltip
                    title={
                      item?.isConfigured
                        ? `${subject?.name} has already been configured for this class in the assessment. Therefore you cannot unselect it`
                        : ""
                    }
                  >
                    <input
                      type="checkbox"
                      checked={item?.checked || false}
                      disabled={!data?.checked || item?.isConfigured}
                      name={item?.name}
                      id={item?.name}
                      onChange={(e) =>
                        handleChange(data.id, e, item?.educationLevelDivisionId)
                      }
                    />
                  </Tooltip>
                  <label htmlFor={item?.name}>{item?.name}</label>
                </div>
                <div className="checkbox">
                  <Tooltip
                    title={
                      item?.isConfigured
                        ? `${subject?.name} has already been configured for this class in the assessment. Therefore you cannot unselect it`
                        : ""
                    }
                  >
                    <input
                      type="checkbox"
                      checked={item?.isCompulsory || false}
                      name="isCompulsory"
                      disabled={
                        !(item?.checked && data?.checked) || item?.isConfigured
                      }
                      onChange={(e) =>
                        handleChange(data.id, e, item?.educationLevelDivisionId)
                      }
                    />
                  </Tooltip>
                  <label htmlFor="isCompulsory">Mandatory</label>
                </div>
              </React.Fragment>
            ))}
          </div>
        ) : (
          <div style={{ minWidth: "200px" }} className="arr-note">
            <strong>Note: </strong>Please configure academic year division
            first.
          </div>
        )}
      </td>
      <td width={270}>
        <Select
          isDisabled={!data?.checked}
          options={staffListOptions}
          name={"staffListSelect"}
          value={staffListOptions?.find(
            (item) => item.value === data?.subjectCoordinatorRecruitmentId,
          )}
          styles={{
            control: { width: "200px" },
          }}
          onChange={(option) => handleChange(data.id, "", "", option, "select")}
          isSearchable={true}
        />
      </td>
    </tr>
  );
};

export default SubjectSettingTableRow;
